/**
 * Field Registry API — Stage 9.1
 * Работа с реестром полей проекта
 */
import apiClient from './client';

export const fieldRegistryAPI = {
  /**
   * Получить все поля реестра
   * @param {Object} params - Параметры фильтрации
   * @param {string} [params.category] - Категория полей
   * @param {string} [params.source] - Источник данных (input, calculated, bitrix, system)
   * @param {boolean} [params.active_only=true] - Только активные поля
   */
  async getAll(params = {}) {
    // Trailing slash важен для FastAPI
    const response = await apiClient.get('/field-registry/', { params });
    return response.data;
  },

  /**
   * Получить поле по ключу
   * @param {string} fieldKey - Ключ поля
   */
  async getByKey(fieldKey) {
    const response = await apiClient.get(`/field-registry/${fieldKey}`);
    return response.data;
  },

  /**
   * Получить поля для конкретной роли
   * @param {string} role - Роль пользователя (finance_admin, senior_manager, viewer)
   * @param {string} [category] - Категория полей
   */
  async getForRole(role, category = null) {
    const params = category ? { category } : {};
    const response = await apiClient.get(`/field-registry/for-role/${role}`, { params });
    return response.data;
  },

  /**
   * Создать новое поле (только admin)
   * @param {Object} fieldData - Данные поля
   */
  async create(fieldData) {
    // POST без trailing slash для этого endpoint
    const response = await apiClient.post('/field-registry/', fieldData);
    return response.data;
  },

  /**
   * Обновить поле (только admin)
   * @param {string} fieldKey - Ключ поля
   * @param {Object} fieldData - Данные для обновления
   */
  async update(fieldKey, fieldData) {
    const response = await apiClient.put(`/field-registry/${fieldKey}`, fieldData);
    return response.data;
  },

  /**
   * Удалить поле (soft delete, только admin)
   * @param {string} fieldKey - Ключ поля
   */
  async delete(fieldKey) {
    const response = await apiClient.delete(`/field-registry/${fieldKey}`);
    return response.data;
  },

  /**
   * Заполнить реестр начальными данными (только admin)
   */
  async seed() {
    const response = await apiClient.post('/field-registry/seed');
    return response.data;
  },
};

export default fieldRegistryAPI;
